module.exports = __webpack_public_path__ + "img/P150T_weapon_104.9509cc8a.png";